import { Box, Stack } from "@mui/material";
import { Suspense, useEffect, useState } from "react";
import { useContext } from "react";
import { LoadingScreen } from "src/components/ui";
import { MenuContext } from "src/contexts/menu-context/MenuContext";

const DashboardPage = ({ children }) => {
  const { selectedTab, newTabContent, newTabItems } = useContext(MenuContext);
  // const tabItem = newTabItems.find((item) => item.id === selectedTab.id);
  //web to mobile 
const [isMobile,setIsMobile] = useState(
    () => typeof window !== "undefined" && window.innerWidth <= 767
  );

    useEffect(() => {
    const mobile = window.innerWidth <= 767;

    if (mobile) {
      setIsMobile(true);

      const mobileBase = process.env.REACT_APP_MOBILE_URL;
      const restOfUrl = window.location.href.replace(
        window.location.origin,
        ""
      );

      window.location.replace(`${mobileBase}${restOfUrl}`);
    }
  }, []);

   if (isMobile) {
    return null;
  }
  return (
    <>
      {newTabContent &&
        newTabContent.map((item, index) => (
          <Box
            key={index} 
            sx={{
              ...(item.id === selectedTab
                ? {
                    display: "block",
                  }
                : {
                    // display: "none",
                    visibility: "hidden",
                  }),
            }}
          >
            <Stack
              id="AVCContaiiner"
              sx={{
                position: "absolute",
                top: "0",
                bottom: "0",
                width: "100%",
                overflowY: "auto",
                scrollBehavior: "smooth",
                overflowX: "hidden",
                zIndex: 1,
                borderRadius: (theme) => `${theme.shape.borderRadius * 3}px`,
              }}
            >
              {!item.loading ? (
                <Suspense fallback={<LoadingScreen open={true} title="لطفا منتظر بمانید ..." />}>
                  <item.content props={item?.props}></item.content>
                </Suspense>
              ) : (
                item.content
              )}
            </Stack>
          </Box>
        ))}
    </>
  );
};

export default DashboardPage;
